import React from 'react'
import { Grid, useMediaQuery } from '@material-ui/core'
import { Table } from './Table/Table'
import RequestCards from './RequestCards/RequestCards'

const UserPanel = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'))

  return (
    <Grid
      container
      direction={'row'}
      justifyContent={'flex-start'}
      alignItems={'center'}
      spacing={2}
      style={{ marginTop: 15 }}
    >
      {isMobile ? <RequestCards /> : <Table />}
    </Grid>
  )
}

export default UserPanel
